export default "__VITE_ASSET__yCPFI$Tq__"